import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import api from '../apis/api';
import { ORGANIZATION } from '../configs/routes';

export const useOrganizationSettings = () => {
    const user = useSelector((state) => state.auth.user);
    const orgId = user?.organization_id || user?.organization;
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchSettings = useCallback(async () => {
        if (!orgId) return null;

        setLoading(true);
        setError(null);
        try {
            const response = await api.get(ORGANIZATION(orgId));
            setSettings(response?.data);
            return response?.data;
        } catch (err) {
            const errorMessage =
                err?.response?.data?.message ||
                err?.response?.data?.error ||
                err?.response?.data?.detail ||
                err?.message ||
                'Failed to load organization settings';
            setError(errorMessage);
            return null;
        } finally {
            setLoading(false);
        }
    }, [orgId]);

    const hasRequiredSettings = useCallback(() => {
        if (!settings) return false;
        return !!(settings?.has_openai_api_key && settings?.teams_tenant_id);
    }, [settings]);

    useEffect(() => {
        if (orgId) {
            fetchSettings();
        }
    }, [orgId, fetchSettings]);

    return {
        settings,
        loading,
        error,
        hasRequiredSettings: hasRequiredSettings(),
        refetch: fetchSettings,
    };
};
